<template>
  <v-flex>
    <v-layout row class="content-header">
      <v-flex md5 class="content-title">
        <h2>Faturas</h2>
        <h4>Consulte e faça download de faturas.</h4>
      </v-flex>
      <v-flex md3>
        <v-text-field
          v-model="search"
          label="Pesquisa"
          placeholder="Apólice, CNPJ, Estipulante..."
          outlined
          class="input-pesquisa"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        &nbsp;<v-btn color="info" @click="pesquisar()"
          ><v-icon>mdi-magnify</v-icon></v-btn
        >
        &nbsp;&nbsp;<v-btn color="info" @click="requestFaturas()"
          >Listar Faturas Disponíveis</v-btn
        >
      </v-flex>
      <v-flex md12>
        <div class="line"></div>
      </v-flex>
    </v-layout>
    <v-layout row class="content-body overflow-y-auto">
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="faturas"
          :items-per-page="topItems"
          :loading="loading"
          :search="search"
          loading-text="Carregando... Por favor aguarde."
          :no-data-text="noDataText"
          no-results-text="Nenhuma informação encontrada"
          :sort-by="['vencimento']"
          :sort-desc="[true]"
          class=""
        >
          <template v-slot:item.anexo="{ item }">
            <br />
            <v-select
              :items="item.opcoes"
              label="Documentos"
              solo
              @change="gerarDocumento"
              class="opcoes-download"
            ></v-select>
          </template>
          <template v-slot:item.emissao="{ item }">
            {{ FormatarData(item.emissao) }}
          </template>
          <template v-slot:item.competencia="{ item }">
            {{
              ("" + item.competencia + "").substring(0, 4) +
                "/" +
                ("" + item.competencia + "").substring(4, 6)
            }}
          </template>
          <template v-slot:item.valor="{ item }">
            {{ FormatarValorMonetario(item.valor) }}
          </template>
          <template v-slot:item.vencimento="{ item }">
            <v-chip
              class="ma-2"
              :color="verificaStatus(item.statusFatura)"
              text-color="white"
            >
              {{ FormatarData(item.vencimento) }}
            </v-chip>
          </template>
        </v-data-table>
      </v-flex>

      <v-overlay :value="fullLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-layout>
  </v-flex>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import Helpers from "@/utilities/Helpers";
import { constants } from "fs";

export default {
  mixins: [Helpers],
  data() {
    return {
      search: "",
      baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
      termoPesquisa: "",
      loading: false,
      fullLoading: false,
      topItems: 10,
      offset: 1,
      options: {},
      headers: [
        { text: "Apólice", value: "apolice", sortable: true },
        { text: "Fatura", value: "fatura", sortable: true },
        { text: "Estipulante/Segurado", value: "estipulante", sortable: true },
        { text: "Emissão", value: "emissao", sortable: true },
        { text: "Competência", value: "competencia", sortable: true },
        { text: "Prêmio(R$)", value: "valor", sortable: true },
        { text: "Vencimento", value: "vencimento", sortable: true },
        { text: "Download", value: "anexo", sortable: false },
      ],
      faturas: [],
      noDataText: "Nenhuma informação pesquisada",
    };
  },
  methods: {
    requestFaturas() {
      this.loading = true;
      this.fullLoading = true;
      let codigoCorretor = this.usuario.codCorretor;

      let url = "ResumoFatura/" + codigoCorretor;

      if (this.search != "") url += "/" + this.search.split("/").join("_");
      // Request apolices
      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          let dados = res.data;

          if (res.data.length == 0) {
            this.noDataText = "Nenhuma informação encontrada";
          }

          for (let item in dados) {
            let retornoOpcoes = this.geraOpcoesDownload(dados[item]);
            dados[item].opcoes = retornoOpcoes;
            //dados[item].emissaoFormatado = this.FormatarData(dados[item].emissao);
            //dados[item].vencimentoFormatado = this.FormatarData(dados[item].vencimento);
            //dados[item].emissao = this.FormatarData(dados[item].emissao);
            //dados[item].vencimento = this.FormatarData(dados[item].vencimento);
          }
          console.log(dados);

          this.faturas = dados;
          //this.search = "";
          this.loading = false;
          this.fullLoading = false;
        })
        .catch((ex) => {
          console.log(ex);
          this.noDataText = "Nenhuma informação encontrada";
          this.loading = false;
          this.fullLoading = true;
        });
    },
    pesquisar() {
      this.requestFaturas();
    },
    FormatarValorMonetario(valor) {
      return valor.toLocaleString("pt-br", { minimumFractionDigits: 2 });
    },
    geraOpcoesDownload(item) {
      let _retorno = [];
      if (item.tipoSistema == "I4PRO") {
        _retorno = [
          {
            text: "Fatura",
            value: {
              documento: "Fatura",
              endereco: item.linkCapaFatura,
              fatura: item.fatura,
              sistema: item.tipoSistema,
            },
          },
          {
            text: "Relação de Vidas(PDF)",
            value: {
              documento: "Relação de Vidas",
              endereco: item.linkRelacaoSegurado,
              fatura: item.fatura,
              sistema: item.tipoSistema,
            },
          },
        ];
        if (item.tipoPagamento.toLowerCase() == "boleto") {
          _retorno.push({
            text: "Boleto",
            value: {
              documento: "Boleto",
              endereco: item.linkBoleto,
              fatura: item.fatura,
              sistema: item.tipoSistema,
            },
          });
        } else {
          _retorno.push({
            text: "Boleto",
            value: {
              documento: "Boleto",
              endereco: "NaoBoleto",
              fatura: item.fatura,
              sistema: item.tipoSistema,
            },
          });
        }
        return _retorno;
      } else {
        _retorno = [
          {
            text: "Fatura",
            value: {
              documento: "Fatura",
              endereco: this.baseURL + "Emissao/FaturaResumo/" + item.fatura,
              fatura: item.fatura,
              sistema: item.tipoSistema,
            },
          },
          {
            text: "Relação de Vidas(PDF)",
            value: {
              documento: "Relação de Vidas(PDF)",
              endereco: this.baseURL + "Emissao/RelacaoSeguradoResumo/" + item.fatura,
              fatura: item.fatura,
              sistema: item.tipoSistema,
            },
          },
        ];

        if (item.tipoPagamento.toLowerCase() == "boleto") {
          _retorno.push({
            text: "Boleto",
            value: {
              documento: "Boleto",
              endereco:
                this.baseURL +
                "Emissao/Boleto/" +
                item.codigoCorretor +
                "/" +
                item.fatura,
              fatura: item.fatura,
              sistema: item.tipoSistema,
            },
          });
        } else {
          _retorno.push({
            text: "Boleto",
            value: {
              documento: "Boleto",
              endereco: "NaoBoleto",
              fatura: item.fatura,
              sistema: item.tipoSistema,
            },
          });
        }

        return _retorno;
      }
    },
    gerarDocumento(value) {

      if (value.tpSistema == "SNGS")
      {
        this.showToast("warning", "Atenção!", "Estes documentos não estão disponíveis para download, entre em contato pelos canais da Previsul.");
      }
      else
      {
        console.log(value);
        if (value.endereco == "NaoBoleto") {
          this.showToast(
            "warning",
            "Atenção",
            "Está apólice não tem esta forma de pagamento. Verifique a escolha do cliente."
          );
        } else {
          if (value.sistema != "I4PRO" && value.documento == "Boleto") {
            this.fullLoading = true;
            let urlConfirmacao =
              "Boleto/existe/" + this.usuario.codCorretor + "/" + value.fatura;

            Vue.prototype.$httpPortal
              .get(urlConfirmacao)
              .then((res) => {
                let retorno = res.data;
                console.log(retorno);
                if (retorno == true) {
                  let url = value.endereco;
                  window.open(url, "_blank");
                } else {
                  this.showToast(
                    "error",
                    "Atenção!",
                    "Arquivo não disponível para download."
                  );
                }

                this.fullLoading = false;
              })
              .catch((ex) => {
                console.log(ex);
                this.noDataText = "Nenhuma informação encontrada";
                this.fullLoading = false;
              });
          } else {
            let url = value.endereco;
            window.open(url, "_blank");
          }
        }
      }      
    },
    verificaStatus(value) {
      if (value == "QUITADO") return "green";
      if (value == "PENDENTE") return "orange";
      if (value == "VENCIDO") return "red";

      return "";
    },
  },
  computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" }),
  },
  filters: {
    formatDateBR(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
  mounted() {
    //this.requestFaturas();
  },
};
</script>

<style lang="scss">
.opcoes-download {
  min-width: 115px !important;
}
</style>
